import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "text-title-underline" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "bg-white p-2" }
const _hoisted_5 = { class: "border-b border-gray-300 mb-4" }
const _hoisted_6 = { class: "flex items-center mb-1" }
const _hoisted_7 = { class: "p-2" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = { class: "border-b border-gray-300 mb-4" }
const _hoisted_11 = { class: "flex items-center mb-1" }
const _hoisted_12 = { class: "p-2" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "flex flex-col md:flex-row" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "flex flex-col md:flex-row" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "flex flex-col md:flex-row" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "flex flex-col md:flex-row" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { class: "flex flex-col md:flex-row" }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "flex flex-col md:flex-row" }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "border-b border-gray-300 mb-4" }
const _hoisted_28 = { class: "flex items-center mb-1" }
const _hoisted_29 = { class: "p-2" }
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = { class: "flex flex-col md:flex-row" }
const _hoisted_32 = { class: "mb-4" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "mb-4" }
const _hoisted_36 = { class: "mb-4" }
const _hoisted_37 = { class: "flex flex-col md:flex-row" }
const _hoisted_38 = { class: "mb-4" }
const _hoisted_39 = { class: "mb-4" }
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = { class: "flex flex-col md:flex-row" }
const _hoisted_42 = { class: "border-b border-gray-300 mb-4" }
const _hoisted_43 = { class: "flex items-center mb-1" }
const _hoisted_44 = { class: "p-2" }
const _hoisted_45 = { class: "mb-4" }
const _hoisted_46 = { class: "mb-4" }
const _hoisted_47 = { class: "flex flex-col md:flex-row" }
const _hoisted_48 = { class: "border-b border-gray-300 mb-4" }
const _hoisted_49 = { class: "flex items-center mb-1" }
const _hoisted_50 = { class: "p-2" }
const _hoisted_51 = { class: "mb-4" }
const _hoisted_52 = { class: "flex flex-col md:flex-row" }
const _hoisted_53 = { class: "mb-4" }
const _hoisted_54 = { class: "flex flex-col md:flex-row" }
const _hoisted_55 = { class: "border-b border-gray-300 mb-4" }
const _hoisted_56 = { class: "p-2" }
const _hoisted_57 = { class: "mb-4" }
const _hoisted_58 = { class: "flex flex-col md:flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('counselingReports.title')) + "作成", 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "text-xs md:text-sm text-blue-500 hover:text-blue-400 hover:border-b border-blue-400",
                to: "/counseling-reports/"
              }, {
                default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                  _createTextVNode(" ＜ カウンセリングレポート一覧へ戻る ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("form", {
                onSubmit: _cache[72] || (_cache[72] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _cache[74] || (_cache[74] = _createElementVNode("p", { class: "font-bold text-black mr-2" }, "日時", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSection('date'))),
                      class: "text-blue-500 text-xs"
                    }, _toDisplayString(_ctx.isSectionOpen.date ? '閉じる▽' : '開く△'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetDate())),
                      class: "rounded-full px-2 py-0.5 bg-gray-400 text-white font-bold text-xs"
                    }, " 入力内容をリセット ")
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.inputParams.implementation_date,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputParams.implementation_date) = $event)),
                          type: "date",
                          placeholder: "カウンセリング実施日",
                          style: {"width":"220px"}
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isSectionOpen.date]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[75] || (_cache[75] = _createElementVNode("p", { class: "font-bold text-black mr-2" }, "クライアント情報", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSection('client'))),
                      class: "text-blue-500 text-sm"
                    }, _toDisplayString(_ctx.isSectionOpen.client ? '閉じる▽' : '開く△'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetClientInfo())),
                      class: "rounded-full px-2 py-0.5 bg-gray-400 text-white font-bold text-xs ml-2"
                    }, " 入力内容をリセット ")
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[76] || (_cache[76] = _createElementVNode("label", {
                        for: "client_name",
                        class: "form-label"
                      }, "名前", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputParams.counseling_client.nick_name) = $event)),
                        id: "client_name",
                        placeholder: "イニシャル・ニックネーム",
                        type: "text",
                        class: "form-input mb-1",
                        style: {"width":"220px"},
                        onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.inputParams.counseling_client.nick_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[77] || (_cache[77] = _createElementVNode("label", {
                        for: "client_age",
                        class: "form-label"
                      }, "年齢", -1)),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.counseling_client.age,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputParams.counseling_client.age) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client_age_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputParams.counseling_client.age_others) = $event)),
                          id: "age_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.counseling_client.age_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[78] || (_cache[78] = _createElementVNode("label", {
                        for: "client_gender",
                        class: "form-label"
                      }, "性別", -1)),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.counseling_client.gender,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.inputParams.counseling_client.gender) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client_gender_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inputParams.counseling_client.gender_others) = $event)),
                          id: "gender_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[12] || (_cache[12] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.counseling_client.gender_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[79] || (_cache[79] = _createElementVNode("label", {
                        for: "client_residence",
                        class: "form-label"
                      }, "居住地", -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.counseling_client.residence,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.inputParams.counseling_client.residence) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client_residence_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.inputParams.counseling_client.residence_others) = $event)),
                          id: "residence_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.counseling_client.residence_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _cache[80] || (_cache[80] = _createElementVNode("label", {
                        for: "client_birthplace",
                        class: "form-label"
                      }, "出身地", -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.counseling_client.birthplace,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.inputParams.counseling_client.birthplace) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client_birthplace_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.inputParams.counseling_client.birthplace_others) = $event)),
                          id: "birthplace_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[18] || (_cache[18] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.counseling_client.birthplace_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _cache[81] || (_cache[81] = _createElementVNode("label", {
                        for: "client_sibling",
                        class: "form-label"
                      }, "兄弟構成", -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.counseling_client.sibling,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.inputParams.counseling_client.sibling) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.session_sibling_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.inputParams.counseling_client.sibling_others) = $event)),
                          id: "sibling_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[21] || (_cache[21] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.counseling_client.sibling_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _cache[82] || (_cache[82] = _createElementVNode("label", {
                        for: "client_circumstance",
                        class: "form-label"
                      }, "生育環境", -1)),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.counseling_client.circumstance,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.inputParams.counseling_client.circumstance) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.session_circumstance_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.inputParams.counseling_client.circumstance_others) = $event)),
                          id: "circumstance_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[24] || (_cache[24] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.counseling_client.circumstance_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[83] || (_cache[83] = _createElementVNode("label", {
                        for: "circumstance_others_detail",
                        class: "form-label"
                      }, "詳細な生育環境", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.inputParams.counseling_client.circumstance_others_detail) = $event)),
                        id: "circumstance_others_detail",
                        placeholder: "記入なし",
                        class: "form-input mb-1 h-20",
                        onKeydown: _cache[26] || (_cache[26] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.inputParams.counseling_client.circumstance_others_detail]
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isSectionOpen.client]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _cache[84] || (_cache[84] = _createElementVNode("p", { class: "font-bold text-black mr-2" }, "セッション内容", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.toggleSection('session'))),
                      class: "text-blue-500 text-sm"
                    }, _toDisplayString(_ctx.isSectionOpen.session ? '閉じる▽' : '開く△'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.resetSession())),
                      class: "rounded-full px-2 py-0.5 bg-gray-400 text-white font-bold text-xs ml-2"
                    }, " 入力内容をリセット ")
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[85] || (_cache[85] = _createElementVNode("label", {
                        for: "session_format",
                        class: "form-label"
                      }, "対面形式", -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.session_format,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.inputParams.session_format) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.session_format_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.inputParams.session_format_others) = $event)),
                          id: "session_format_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[31] || (_cache[31] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.session_format_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[86] || (_cache[86] = _createElementVNode("label", {
                        for: "client_concerns",
                        class: "form-label"
                      }, "クライアントの主訴", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.inputParams.client_concerns) = $event)),
                        id: "client_concerns",
                        placeholder: "記入なし",
                        type: "text",
                        class: "form-input mb-1",
                        onKeydown: _cache[33] || (_cache[33] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.inputParams.client_concerns]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _cache[87] || (_cache[87] = _createElementVNode("label", { class: "form-label" }, "セッションテーマ", -1)),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: _ctx.selectedSessionThemes,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.selectedSessionThemes) = $event)),
                          onChange: _cache[35] || (_cache[35] = ($event: any) => (_ctx.handleCheckboxChange('selectedSessionThemes', $event)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessionThemes, (theme) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: theme.id,
                                label: theme.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "text-xs md:text-sm",
                                    style: _normalizeStyle({ color: theme.theme_color })
                                  }, _toDisplayString(theme.session_theme_name), 5)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.inputParams.session_theme_others) = $event)),
                          id: "session_theme_others",
                          placeholder: "記入なし",
                          type: "text",
                          class: "form-input mb-1",
                          onKeydown: _cache[37] || (_cache[37] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.session_theme_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[88] || (_cache[88] = _createElementVNode("label", {
                        for: "session_g",
                        class: "form-label"
                      }, "セッションのG", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.inputParams.session_g) = $event)),
                        id: "session_g",
                        placeholder: "記入なし",
                        type: "text",
                        class: "form-input mb-1",
                        onKeydown: _cache[39] || (_cache[39] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.inputParams.session_g]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[89] || (_cache[89] = _createElementVNode("label", {
                        for: "session_r",
                        class: "form-label"
                      }, "セッションのR", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.inputParams.session_r) = $event)),
                        id: "session_r",
                        placeholder: "記入なし",
                        type: "text",
                        class: "form-input mb-1",
                        onKeydown: _cache[41] || (_cache[41] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.inputParams.session_r]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _cache[90] || (_cache[90] = _createElementVNode("label", {
                        for: "session_type",
                        class: "form-label"
                      }, "セッション種別", -1)),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.session_type,
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.inputParams.session_type) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.session_type_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.inputParams.session_type_others) = $event)),
                          id: "session_type_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[44] || (_cache[44] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.session_type_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[91] || (_cache[91] = _createElementVNode("label", { class: "form-label" }, "扱ったノイズ", -1)),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: _ctx.selectedMentalNoises,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.selectedMentalNoises) = $event)),
                          onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.handleCheckboxChange('selectedMentalNoises', $event)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mentalNoises, (noise) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: noise.id,
                                label: noise.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "text-xs md:text-sm",
                                    style: _normalizeStyle({ color: noise.theme_color })
                                  }, _toDisplayString(noise.mental_noise_name), 5)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.inputParams.session_mentalnoise_others) = $event)),
                          id: "session_mentalnoise_others",
                          placeholder: "記入なし",
                          type: "text",
                          class: "form-input mb-1",
                          onKeydown: _cache[48] || (_cache[48] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.session_mentalnoise_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _cache[92] || (_cache[92] = _createElementVNode("label", {
                        for: "session_findings",
                        class: "form-label"
                      }, "セッション後の所見等", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.inputParams.session_findings) = $event)),
                        id: "session_findings",
                        placeholder: "記入なし",
                        class: "form-input mb-1 h-20",
                        onKeydown: _cache[50] || (_cache[50] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.inputParams.session_findings]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _cache[93] || (_cache[93] = _createElementVNode("label", {
                        for: "session_time",
                        class: "form-label"
                      }, "セッションの時間", -1)),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.session_time,
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.inputParams.session_time) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.session_time_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.inputParams.session_time_others) = $event)),
                          id: "session_time_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[53] || (_cache[53] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.session_time_others]
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isSectionOpen.session]
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _cache[94] || (_cache[94] = _createElementVNode("p", { class: "font-bold text-black mr-2" }, "経過", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.toggleSection('progress'))),
                      class: "text-blue-500 text-sm"
                    }, _toDisplayString(_ctx.isSectionOpen.progress ? '閉じる▽' : '開く△'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.resetProgress())),
                      class: "rounded-full px-2 py-0.5 bg-gray-400 text-white font-bold text-xs ml-2"
                    }, " 入力内容をリセット ")
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[95] || (_cache[95] = _createElementVNode("label", { class: "form-label" }, "クライアントの現実変化", -1)),
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: _ctx.selectedClientChangeds,
                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.selectedClientChangeds) = $event)),
                          onChange: _cache[57] || (_cache[57] = ($event: any) => (_ctx.handleCheckboxChange('selectedClientChangeds', $event)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientChangeds, (changeds) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: changeds.id,
                                label: changeds.id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(changeds.client_changed_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.inputParams.session_changed_others) = $event)),
                          id: "session_changed_others",
                          placeholder: "記入なし",
                          type: "text",
                          class: "form-input mb-1",
                          onKeydown: _cache[59] || (_cache[59] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.session_changed_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _cache[96] || (_cache[96] = _createElementVNode("label", {
                        for: "client_age",
                        class: "form-label"
                      }, "継続予定", -1)),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.continue_plan,
                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.inputParams.continue_plan) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.continue_plan_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.inputParams.continue_plan_others) = $event)),
                          id: "continue_plan_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[62] || (_cache[62] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.continue_plan_others]
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isSectionOpen.progress]
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[97] || (_cache[97] = _createElementVNode("p", { class: "font-bold text-black mr-2" }, "ビジネスについて", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.toggleSection('business'))),
                      class: "text-blue-500 text-sm"
                    }, _toDisplayString(_ctx.isSectionOpen.business ? '閉じる▽' : '開く△'), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.resetBusiness())),
                      class: "rounded-full px-2 py-0.5 bg-gray-400 text-white font-bold text-xs ml-2"
                    }, " 入力内容をリセット ")
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _cache[98] || (_cache[98] = _createElementVNode("label", {
                        for: "client_age",
                        class: "form-label"
                      }, "クラアント集客経路", -1)),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.client_route,
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.inputParams.client_route) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.client_route_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.inputParams.client_route_others) = $event)),
                          id: "client_route_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[67] || (_cache[67] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.client_route_others]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _cache[99] || (_cache[99] = _createElementVNode("label", {
                        for: "client_age",
                        class: "form-label"
                      }, "価格（一回あたり換算）", -1)),
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.inputParams.session_price,
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.inputParams.session_price) = $event)),
                          placeholder: "記入なし",
                          style: {"width":"274px"},
                          class: "mb-2 md:mb-0 md:mr-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.session_price_options, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.inputParams.session_price_others) = $event)),
                          id: "session_price_others",
                          placeholder: "その他備考",
                          type: "text",
                          class: "form-input mb-1 md:mb-0 md:ml-2",
                          onKeydown: _cache[70] || (_cache[70] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                        }, null, 544), [
                          [_vModelText, _ctx.inputParams.session_price_others]
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isSectionOpen.business]
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _cache[102] || (_cache[102] = _createElementVNode("div", { class: "flex items-center mb-1" }, [
                    _createElementVNode("p", { class: "font-bold text-black mr-2" }, "公開について（協会カウンセラーのみに公開されます）")
                  ], -1)),
                  _withDirectives(_createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.inputParams.is_hidden,
                          "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.inputParams.is_hidden) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, { label: 'false' }, {
                              default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                                _createTextVNode("公開", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: 'true' }, {
                              default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                                _createTextVNode("非公開", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.isSectionOpen.business]
                  ])
                ]),
                _cache[103] || (_cache[103] = _createElementVNode("div", { class: "flex justify-center my-10" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "bg-mentalncText text-white p-2 rounded font-bold text-base md:text-xl"
                  }, "カウンセリングレポートを作成")
                ], -1))
              ], 32)
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}